const digest = 'e6582cd9ffdaaba396681301a69d869f95a1ec9f67b36c825d4078d51a2e0f7b';
const css = `._successModalCloseButton_v9oj9_1{display:block;margin:0 auto}._center_v9oj9_6{align-items:center;display:flex;justify-content:center}`;
(function() {
  if (global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'successModalCloseButton': '_successModalCloseButton_v9oj9_1', 'center': '_center_v9oj9_6' };
export const successModalCloseButton = '_successModalCloseButton_v9oj9_1';
export const center = '_center_v9oj9_6';
export { css, digest };